export class _figures{
    constructor({section, formName}) {
        this.section = section;
        this.methodogy = []
        this.mortgage = this.section.mortgage;
        this.formName = formName;
        this.warnings = [];
        this._total = 0;
    }

    append({description, amount, uploadID, operator}) {
        this.methodogy.push({description, amount, uploadID, operator})
    }

    warn(message){
        this.warnings.push(message);
    }

    total(amount){
        this._total = amount;
    }

    get dataSource(){
        return {
            formName: this.formName,
            methodology: this.methodogy,
            total: this._total,
            warnings: this.warnings,
        }
    }
}